"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationWrapper = exports.StyledText = exports.StyledInformationIcon = exports.StyledWarningIcon = exports.StyledErrorIcon = exports.StyledSuccessIcon = exports.StyledIconContainer = exports.StyledNotification = exports.ANIMATION_DURATION = void 0;
const Error_1 = __importDefault(require("@kawaui/icons/build/icons/informative/Error"));
const Success_1 = __importDefault(require("@kawaui/icons/build/icons/informative/Success"));
const Warning_1 = __importDefault(require("@kawaui/icons/build/icons/informative/Warning"));
const styled_components_1 = __importStar(require("styled-components"));
exports.ANIMATION_DURATION = 400;
const getVariantColor = (variant) => {
    switch (variant) {
        case 'error':
            return 'error';
        case 'information':
            return 'info';
        case 'success':
            return 'ok';
        case 'warning':
            return 'warn';
    }
};
const colorHelper = (variant) => {
    const variantColor = getVariantColor(variant);
    return (0, styled_components_1.css) `
    color: ${({ theme }) => theme.colors.status[variantColor]};
    background-color: ${({ theme }) => theme.colors.status.light[variantColor]};
    border-color: ${({ theme }) => theme.colors.status[variantColor]};
  `;
};
exports.StyledNotification = styled_components_1.default.div `
  /* Display & Box Model */
  display: flex;
  align-items: center;
  width: 360px;
  box-sizing: border-box;
  padding: 12px 16px;
  border: 1px solid;
  border-radius: 2px;

  /* Color */
  ${({ variant }) => variant && colorHelper(variant)};
  box-shadow: ${({ theme }) => theme.shadow.z4};

  @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    width: auto;
    max-width: 416px;
    padding: 12px 32px;
  }
`;
const translateHelper = (0, styled_components_1.css) `
  ${exports.StyledNotification} {
    transition-property: transform;
    transition-duration: inherit;
    transition-timing-function: inherit;
  }

  &.enter-active,
  &.enter-done {
    ${exports.StyledNotification} {
      transform: translateY(8px);
      @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
        transform: translateY(16px);
      }
    }
  }
`;
const cssTransitionHelper = (0, styled_components_1.css) `
  opacity: 0;

  transition-property: opacity;
  transition-duration: ${exports.ANIMATION_DURATION}ms;
  transition-timing-function: ease-in-out;

  &.enter-active,
  &.enter-done {
    opacity: 1;
  }

  ${translateHelper};
`;
exports.StyledIconContainer = styled_components_1.default.div `
  /* Display & Box Model */
  display: flex;
  align-items: center;
  height: 24px;
  width: 24px;
  margin-right: 16px;
`;
exports.StyledSuccessIcon = (0, styled_components_1.default)(Success_1.default) `
  path {
    fill: ${({ theme }) => theme.colors.status.ok};
  }
`;
exports.StyledErrorIcon = (0, styled_components_1.default)(Error_1.default) `
  path {
    fill: ${({ theme }) => theme.colors.status.error};
  }
`;
exports.StyledWarningIcon = (0, styled_components_1.default)(Warning_1.default) `
  path {
    fill: ${({ theme }) => theme.colors.status.warn};
  }
`;
exports.StyledInformationIcon = (0, styled_components_1.default)(Warning_1.default) `
  path {
    fill: ${({ theme }) => theme.colors.status.info};
  }
`;
exports.StyledText = styled_components_1.default.p `
  /* Display & Box Model */
  flex: 1;
  margin: 0;

  /* Text */
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.text)}
`;
exports.NotificationWrapper = styled_components_1.default.div `
  ${cssTransitionHelper};
`;
